import { iAccess } from "../../../definitions/Access"
import { iSubRoute } from "../../../definitions/interfaces"
import { iPermission } from "../../../store/permissions/types"
import { iUserInitialData } from "../../../store/user/types"

interface iProps {
  urlPrefix: string
  access?: iAccess
  user?: iUserInitialData
  permissions?: iPermission[]
}
export function getSpaceRoutes({
  urlPrefix = "",
  access,
  user,
  permissions,
}: iProps): iSubRoute[] {
  const r = routes.map((route) => {
    if (!permissions?.find((p) => p.name === "Dashboard.Admin")) {
      if (route.permission) {
        const usr = access?.users.find((x) => x._id === user?._id)
        if (!usr || usr.role !== route.permission) {
          return null
        }
      }
    }
    return { ...route, route: urlPrefix + route.route }
  })

  return r.filter((x) => x !== null) as iSubRoute[]
}

const routes: iSubRoute[] = [
  {
    title: "Overview",
    route: "",
  },
  {
    title: "About",
    route: "/about",
  },
  {
    title: "Uploads",
    route: "/manage-files",
  },
  {
    title: "Access",
    route: "/access",
  },
]
